import controller from './templates.controller';
import templateBase from './templates/templates-base.view.html';
import adaptativo from "./templates/templates-adaptative.vew.html";

let TemplatesComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative){
    return adaptativo;
  } else {
      return templateBase;
  }
}

export default TemplatesComponent;



/** WEBPACK FOOTER **
 ** ./www/components/templates/templates.component.js
 **/